import React, { useEffect, useState } from "react";
import "../styles/play.css";

export default function Play() {
  const [started, setStarted] = useState(false);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  const [box, setBox] = useState({ x: 120, y: 200 });

  useEffect(() => {
    if (!started || gameOver) return;

    const speed = Math.max(300, 900 - score * 10);

    const move = setTimeout(() => {
      setGameOver(true);
    }, speed);

    return () => clearTimeout(move);
  }, [started, score, gameOver]);

  const hit = () => {
    if (!started) {
      setStarted(true);
      return;
    }

    if (gameOver) return;

    setScore((s) => s + 1);

    const x = Math.random() * (window.innerWidth - 100);
    const y = Math.random() * (window.innerHeight - 200);

    setBox({ x, y });
  };

  const restart = () => {
    setScore(0);
    setGameOver(false);
    setStarted(true);
  };

  return (
    <div className="game">
      
      {/* START SCREEN */}
      {!started && (
        <div className="center">
          <div className="game-icon">🎮</div>

          <h1 className="game-title">
            Tap Challenge
          </h1>

          <p className="game-desc">
            Tap the <b>Eyal coin</b> as fast as you can.  
            Don't miss — the game ends instantly!
          </p>

          <div className="game-rules">
            ⚡ Speed increases every tap <br/>
                       
          </div>

          <button 
            className="start-btn"
            onClick={() => setStarted(true)}
          >
            Start Game
          </button>
        </div>
      )}

      {/* GAME OVER */}
      {gameOver && (
        <div className="center">
          <h2>Game Over</h2>
          <p>Score: {score}</p>
          <button onClick={restart}>Play Again</button>
        </div>
      )}

      {/* GAME */}
      {started && !gameOver && (
        <>
          <div className="score">{score}</div>

          <div
            className="target"
            onClick={hit}
            style={{
              left: box.x,
              top: box.y,
            }}
          />
        </>
      )}
    </div>
  );
}